import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment';
import DayPicker, { DateUtils } from 'react-day-picker';
import LocaleUtils from 'react-day-picker/moment';

import OutsideClickHandler from './OutsideClickHandler';
import Button from './Button';
import { formatDate } from '../../utils/date';
import 'react-day-picker/lib/style.css';
import './PeriodPicker.scss';



export default class PeriodPicker extends PureComponent {
  static propTypes = {
    disabledDays: PropTypes.array,
    fromDate: PropTypes.any,
    toDate: PropTypes.any,
    onFromChange: PropTypes.func.isRequired,
    onToChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleFromClick = this.handleFromClick.bind(this);
    this.handleToClick = this.handleToClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);

    const { fromDate, toDate } = this.props;

    this.state = {
      isSelecting: null,
      fromDate,
      toDate,
      allowedFrom: moment().add(14, 'days').toDate() // @TODO server time
    }
  }

  // update values on prop changes;
  componentWillReceiveProps(nextProps, nex) {
    const { fromDate, toDate } = nextProps;
    if (this.state.fromDate !== fromDate || this.state.toDate !== toDate) {
      this.setState({fromDate, toDate});
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.isSelecting !== null && nextState.isSelecting === null) {
      this.onBlur();
    }
  }

  handleDayClick(day,  { disabled, selected }) {
    if (disabled) { return };

    const { isSelecting, fromDate } = this.state;

    if (isSelecting === 'from') {
      this.setState({
        isSelecting: 'to',
        fromDate: day,
        toDate: null,
      });

    } else if (isSelecting === 'to') {
      if (fromDate) {
        const days = Math.floor(( day - fromDate ) / 86400000) + 1; // inclusive  
        if (days <= 1) {
          // Reset, the from-day if the clicked day is before the current from-day
          this.setState({
            fromDate: day,
            toDate: null,
          });
        } else if (days >= 7 && days <= 365) {
          this.setState({
            isSelecting: null,
          });
        }
      }
    }
  }

  handleDayMouseEnter(day, { disabled, selected }) {
    if (disabled) {
      return;
    }

    const { fromDate } = this.state;
    if (
      this.state.isSelecting !== 'to'
      || (fromDate && day < fromDate) // Before start
      || DateUtils.isSameDay(day, fromDate) // Same date
    ) {
      return;
    }

    this.setState({ toDate: day });
  }

  handleOutsideClick(e) {
    const { isSelecting } = this.state;
    if (isSelecting) {
      this.setState({
        isSelecting: null
      });
    }
  }

  handleFromClick() {
    this.setState({
      isSelecting: 'from'
    });
  }

  handleToClick() {
    this.setState({
      // Jump to from if it's missing
      isSelecting: this.state.fromDate? 'to' : 'from'
    });
  }

  onBlur = () => {
    const {
      onFromChange,
      onToChange,
      fromDate: currentFrom,
      toDate: currentTo
    } = this.props;

    const { fromDate, toDate } = this.state;
    if (currentFrom !== fromDate) {
      onFromChange(fromDate)
    }

    if (currentTo !== toDate) {
      onToChange(toDate);
    }
  }

  render() {
    const { disabledDays } = this.props;
    const { isSelecting, fromDate, toDate, allowedFrom } = this.state;

    const fromLabel = fromDate ? formatDate(fromDate) : 'No';
    const toLabel = toDate ? formatDate(toDate) : 'Līdz';

    return (
      <OutsideClickHandler className="period-picker" onOutsideClick={this.handleOutsideClick}>
        <div className="btn-group col">
          <Button
            active={isSelecting === 'from'}
            hasValue={!!fromDate}
            onClick={this.handleFromClick}
            label={fromLabel}
          />
          <Button
            active={isSelecting === 'to'}
            hasValue={!!toDate}
            onClick={this.handleToClick}
            label={toLabel}
          />
        </div>

        { this.state.isSelecting !== null &&
          <div className="overlay">
            <DayPicker
              locale="lv"
              localeUtils={LocaleUtils}
              numberOfMonths={2}
              fromMonth={allowedFrom}
              selectedDays={[fromDate, {from: fromDate, to: toDate}]}
              disabledDays={[{before: allowedFrom}, ...disabledDays]}
              modifiers={{
                start: fromDate,
                end: toDate,
              }}
              onDayClick={this.handleDayClick}
              onDayMouseEnter={this.handleDayMouseEnter}
            />
          </div>
        }
      </OutsideClickHandler>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PeriodPicker/index.js